import type { CSSProperties } from "react";

export type RecordIconVariant = "record" | "pause" | "resume" | "stop";

export interface RecordIconProps {
  variant: RecordIconVariant;
  size?: number;
  /** Fill colour. Defaults to currentColor so it inherits the button's text
   *  colour — keeps the grayscale-only system intact (no colour introduced). */
  color?: string;
  style?: CSSProperties;
}

/**
 * Retro tape-deck transport glyphs, drawn as solid grayscale SVG (no icon
 * library — DESIGN.md bans Lucide/Heroicons but allows hand-rolled SVG, same
 * as ShareIcon). Filled symbols read as the physical keys of a 1970s recorder:
 *   record = solid dot, stop = solid square (square corners, --radius:0),
 *   pause = two bars, resume = play triangle.
 */
export function RecordIcon({
  variant,
  size = 18,
  color = "currentColor",
  style,
}: RecordIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      {variant === "record" && <circle cx={12} cy={12} r={6} />}
      {variant === "stop" && <rect x={6} y={6} width={12} height={12} />}
      {variant === "pause" && (
        <>
          <rect x={7} y={5} width={3.5} height={14} />
          <rect x={13.5} y={5} width={3.5} height={14} />
        </>
      )}
      {variant === "resume" && <path d="M7 4 L19 12 L7 20 Z" />}
    </svg>
  );
}
